export const colors = {
  MainBlue: "var(--MainBlue)",
  Sky: "var(--Sky)",
  GrayBlue: "var(--GrayBlue)",
  Aqua: "var(--Aqua)",
  Green: "var(--Green)",
  DeepSea: "var(--DeepSea)",
  Orange: "var(--Orange)",
  Yellow: "var(--Yellow)",
  Grass: "var(--Grass)",
  Lime: "var(--Lime)",
  Violet: "var(--Violet)",
  Salmon: "var(--Salmon)",
  Red: "var(--Red)",
  Olive: "var(--Olive)",
  Forest: "var(--Forest)",
  Purple: "var(--Purple)",
  Plum: "var(--Plum)",
  Pink: "var(--Pink)",
  Brown: "var(--Brown)",

  // Legacy1
  Black: "var(--Black)",
  White: "var(--White)",
  DarkNavy: "var(--DarkNavy)",
  LightNavy: "var(--LightNavy)",
  MidNavy: "var(--MidNavy)",
  Gray: "var(--Gray)",
  LightGray: "var(--LightGray)",
  GhostWhite: "var(--GhostWhite)",

  // Legacy2
  LightRed: "var(--LightRed)",
  Blue: "var(--Blue)",
  MainBlueDark: "var(--MainBlueDark)",
  LightOrange: "var(--LightOrange)",
  LightYellow: "var(--LightYellow)",
  LightGreen: "var(--LightGreen)",
  LightBlue: "var(--LightBlue)",

  withOpacity: (color, opacity) => {
    let hex = color;

    if (color.startsWith("var(")) {
      const varName = color.replace("var(", "").replace(")", "").trim();
      hex = getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
    }

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  },

  BlueScale: ["var(--MainBlue)", "#5E90C9", "#93B5DB", "#C9DAED"],
};
